import React from "react";
import { computeDelta } from "./DeltaBadge";

const LeakageBanner = ({ noShowCurrent = 0, noShowPrevious = 0, cancellationCurrent = 0, cancellationPrevious = 0, currency = "AED" }) => {
  const total = noShowCurrent + cancellationCurrent;
  const prevTotal = noShowPrevious + cancellationPrevious;

  if (total === 0 && prevTotal === 0) return null;

  const { pct, direction } = computeDelta(total, prevTotal, true);
  const improved = direction === "down";
  const arrow = improved ? "↓" : direction === "up" ? "↑" : "–";
  const pctLabel = pct != null ? `${arrow} ${pct}% ${improved ? "improvement" : "increase"}` : "";

  return (
    <div style={{
      background: "#FEF2F2", border: "1px solid #FECACA", borderRadius: "8px",
      padding: "16px 20px", marginTop: "24px",
    }}>
      <div style={{ display: "flex", alignItems: "flex-start", gap: "12px" }}>
        <span style={{ fontSize: "20px", flexShrink: 0 }}>⚠️</span>
        <div>
          <div style={{ fontSize: "14px", fontWeight: "600", color: "#991B1B", marginBottom: "4px" }}>
            Revenue Leakage Alert
          </div>
          <div style={{ fontSize: "13px", color: "#7F1D1D", lineHeight: 1.6 }}>
            This period:{" "}
            <strong>{currency} {total.toLocaleString()}</strong> in estimated lost revenue —{" "}
            {currency} {noShowCurrent.toLocaleString()} from no-shows, {currency} {cancellationCurrent.toLocaleString()} from cancellations.
          </div>
          {prevTotal > 0 && (
            <div style={{ fontSize: "12px", color: "#9CA3AF", marginTop: "4px" }}>
              vs {currency} {prevTotal.toLocaleString()} last period
              {pctLabel && (
                <span style={{ marginLeft: "6px", color: improved ? "#059669" : "#DC2626", fontWeight: "600" }}>
                  {pctLabel}
                </span>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LeakageBanner;
